import { Button, Modal, Radio } from "antd";
import { ReactNode, useState } from "react";
import { EtapaVerificacion } from "../../../utils/verificacionAdministrativa";

type IProps = {
  visible: boolean;
  onCancel: () => void;
  onConfirmar: (etapa: EtapaVerificacion) => void;
  titulo?: string;
  /** Contexto de lo que se va a verificar: cuántas propuestas, cuáles se omiten, etc. */
  detalle?: ReactNode;
  cargando?: boolean;
};

/**
 * Pregunta en qué etapa del proceso se está verificando, porque de eso depende la consecuencia:
 *
 * - Primera verificación: lo administrativo se manda a subsanar.
 * - Informe final: lo que no se subsanó se rechaza, y la observación se reescribe empezando por
 *   "Se rechaza ya que no subsanó…", como exige el lineamiento.
 */
export const ModalEtapaVerificacion = ({
  visible,
  onCancel,
  onConfirmar,
  titulo = "Verificar con IA",
  detalle,
  cargando = false,
}: IProps) => {
  const [etapa, setEtapa] = useState<EtapaVerificacion>("primera");

  return (
    <Modal
      className="ant-modal-close-x2"
      title={<span className="font-family-Monserrat-SemiBold font-size-14px">{titulo}</span>}
      visible={visible}
      onCancel={onCancel}
      width={620}
      footer={[
        <Button key="cancelar" className="button-blanco-radius" onClick={onCancel} disabled={cargando}>
          Cancelar
        </Button>,
        <Button
          key="verificar"
          className="button-azul-radius ms-1"
          onClick={() => onConfirmar(etapa)}
          loading={cargando}
          disabled={cargando}
        >
          Verificar
        </Button>,
      ]}
    >
      <div className="font-size-14px font-family-Montserrat-Regular">
        {detalle}

        <div className="font-family-Monserrat-SemiBold pb-2">¿En qué etapa se está verificando?</div>

        <Radio.Group
          value={etapa}
          onChange={(e) => setEtapa(e.target.value)}
          style={{ display: "flex", flexDirection: "column", gap: "12px" }}
        >
          <Radio value="primera">
            <span className="font-family-Monserrat-SemiBold">Primera verificación</span>
            <div className="font-size-13px font-color-4B4B4B" style={{ marginLeft: "24px" }}>
              Los documentos con hallazgos quedan marcados para <b>subsanar</b>, con la observación de
              lo que debe corregir el participante.
            </div>
          </Radio>

          <Radio value="segunda">
            <span className="font-family-Monserrat-SemiBold">Informe final (segunda verificación)</span>
            <div className="font-size-13px font-color-4B4B4B" style={{ marginLeft: "24px" }}>
              Lo que sigue sin subsanarse queda <b>rechazado</b>, y la observación se reescribe
              empezando por "Se rechaza ya que no subsanó…". Úsala solo después de vencido el plazo
              de subsanación.
            </div>
          </Radio>
        </Radio.Group>

        <p className="font-size-13px font-color-4B4B4B" style={{ marginTop: "16px" }}>
          En ambos casos el estado de la propuesta no cambia: queda esperando que un profesional
          revise y confirme.
        </p>
      </div>
    </Modal>
  );
};
